import { sidebarStore } from "Components/Core/Sidebar/SidebarStore";
import { MenuItemWithBadge, SubmenuItem } from "Components/Core/Sidebar/subMenus";

type SubMenus = "PRINTJOBS" | "PROJECTSTATE" | "ACTIVITY_REPORTS";
export const subMenuConfig = {
  get config(): SubmenuItem[] {
    const mainModuleChildren = sidebarStore.menu?.find((m) => m.module === "REPORTS")?.children;
    const config = [
      {
        label: <MenuItemWithBadge label={`Print jobs`} />,
        link: "printJobs",
      },
    ];
    if (mainModuleChildren) {
      const subModules = mainModuleChildren.map((m) => m.module) as SubMenus[];
      subModules.includes("PROJECTSTATE") &&
        config.push({
          label: <MenuItemWithBadge label={`Project state`} />,
          link: "projectState",
        });
      subModules.includes("ACTIVITY_REPORTS") &&
        config.push({
          label: <MenuItemWithBadge label={`Activity reports`} />,
          link: "activity",
        });
    }

    return config;
  },
};
